import { Box, Static } from "ink";
import React, { FC, useEffect, useMemo, useState } from "react";

import Log, { LogType, LogValue } from "./log";

export const methods = ["dir", "log", "info", "warn", "error"];

interface LogItem {
	id: number;
	type: LogType;
	values: LogValue[];
}

type LogMethod = (args: LogValue[]) => void;
type Logger = Record<string, LogMethod>;

const useConsoleMonkeyPatch = () => {
	const [logs, setLogs] = useState([] as LogItem[]);

	const onLog = useMemo(() => {
		const customLogs: Logger = {};

		for (const method of methods) {
			customLogs[method] = (...args: LogValue[]) => {
				setLogs(l => [
					...l,
					method === "dir"
						? { id: l.length, type: "dir", values: [args[0]] }
						: {
								id: l.length,
								type: method as LogType,
								values: args
						  }
				]);
			};
		}

		return customLogs;
	}, []);

	useEffect(() => {
		const orig: Logger = {};
		const consoleAccessor: Logger = (console as unknown) as Logger;

		for (const method of methods) {
			orig[method] = consoleAccessor[method];
			consoleAccessor[method] = onLog[method];
		}

		return () => {
			for (const method of methods) {
				consoleAccessor[method] = orig[method];
			}
		};
	}, [onLog]);

	return logs;
};

const Console: FC = ({ children }) => {
	const logs = useConsoleMonkeyPatch();

	return (
		<>
			<Static items={logs}>{log => <Log key={log.id} {...log} />}</Static>
			<Box marginY={2}>{children}</Box>
		</>
	);
};

export default Console;
